import React, { Component, Suspense } from "react";
import { HashRouter, Route, Routes, Switch } from "react-router-dom";
import "./scss/style.scss";
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import { connect, useSelector } from "react-redux";
import Cookies from "js-cookie";
import setAuthToken from "./utils/setAuthToken";
import PrivateRoute from "./components/privateRoute/PrivateRoute";
import CreatePlan from "./views/subscriptionAdmin/createPlan";
import CreateCoupon from "./views/coupon/createBundle";
import { SignOut } from "./modules/auth/actions";
import jwt_decode from "jwt-decode";
import store from "./store";
import { setCurrentUser } from "./modules/auth/actions";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./views/auth/login"));
const Subscription = React.lazy(() => import("./views/subscriptionWeb/subscriptionWeb"));
const Checkout = React.lazy(() => import("./views/subscriptionWeb/subscriptionCheckout"));
import SuccessModal from "./components/SuccessModal";
import ErrorModal from "./components/errorModal";
import { Er } from "react-flags-select";
// const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
// const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

if (Cookies.get("token")) {
  // Set auth token header auth
  const token = Cookies.get("token");
  setAuthToken(token);
  // Decode token and get user info and exp
  const decoded = jwt_decode(token);
  // Set user and isAuthenticated
  store.dispatch(setCurrentUser(decoded));
  // Check for expired token
  const currentTime = Date.now() / 1000; // to get in milliseconds
  if (decoded.exp < currentTime) {
    // Logout user
    store.dispatch(SignOut());

    // Redirect to login
    window.location.href = "./login";
  }
}

class App extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { auth } = this.props;
    return (
      <>
        <NotificationContainer />
        <HashRouter>
          <React.Suspense fallback={loading}>
            <Route exact path="/" name="login" component={Login} />
            <Route exact path="/login" name="login" component={Login} />
            <Route exact path="/success" name="Success" component={SuccessModal} />
            <Route exact path="/error" name="Success" component={ErrorModal} />
            <Route exact path="/list-subscription/:id" name="List Subscription" component={Subscription} />
            {/* <Route exact path="/subscription-success" name="Succes" component={SubscriptionSuccess} /> */}
            <Route exact path="/checkout-subscription/:id" name="Checkout Subscription" component={Checkout} />
            {/* <Route exact path="/checkout-subscription/:id/:pricId" name="Checkout Subscription" component={Checkout} /> */}
            {/* <Route exact path="/checkout-subscription/:id/:pricId" name="Checkout Subscription" component={Checkout} /> */}
            
            <Switch>
              <PrivateRoute path="/admin" component={DefaultLayout} />
            </Switch>

            {/* User Management Route */}
          </React.Suspense>
          {/* <Suspense fallback={loading}>
            <Routes>
              <Route
                exact
                path="/login"
                name="Login Page"
                element={<Login />}
              />
              <Route
                exact
                path="/list-subscription"
                name="List Subscription"
                element={<Subscription />}
              />
              <Route
                exact
                path="/checkout-subscription"
                name="Checkout Subscription"
                element={<Checkout />}
              />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <DefaultLayout />
                  </PrivateRoute>
                }
              />
            </Routes>
          </Suspense> */}
        </HashRouter>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});
export default connect(mapStateToProps, {})(App);
